<template>
  <div>
    <div class="button-bar">
      <div class="items1">
        <WDStepTitle
          :propsMode="propsMode"
          :quoteType="quoteType"
          :quoteId="quoteId"
          :status="vehicle.status"
        />
      </div>
      <div class="items2">
        <div>
          <button
            v-if="propsData.status == 1"
            class="btn btn-success btn-sm"
            data-toggle="tooltip"
            data-placement="top"
            title="Save quote"
            @click="fnSaveApplication((isSave = true))"
          >
            <i class="lar la-save"></i>Save
          </button>
        </div>
        <div v-if="fnIsShowUnlockButton()">
          <div>
            <appModalUnlockMessage
              :propsData="propsData"
              v-if="getIsLock == true"
            ></appModalUnlockMessage>
            <button
              v-if="getIsLock != true"
              class="btn btn-success btn-sm"
              data-toggle="tooltip"
              data-placement="top"
              title="Save quote"
              @click="fnSaveApplication((isSave = true))"
            >
              <i class="lar la-save"></i>Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-12 col-lg-12 col-xl-6">
        <div class="row mt-3">
          <div class="col-12">
            <div class="mb-3">
              <h5 class="text-info mb-0">Employment Details</h5>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-12">
            <div class="form-group">
              <input
                class="form-control"
                type="text"
                id="employerName"
                autocomplete="off_employerName"
                placeholder=" "
                v-model="employment.employerName"
              />
              <label class="floatingLabel" for="employerName"
                >Employer Name</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['employment.employerName']"
              >
                {{ fnReplace(getQuoteErrors['employment.employerName']) }}
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-12">
            <div class="form-group">
              <input
                class="form-control"
                type="text"
                id="occupation"
                autocomplete="off_occupation"
                placeholder=" "
                v-model="employment.occupation"
              />
              <label class="floatingLabel" for="occupation">Occupation</label>
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['employment.occupation']"
              >
                {{ fnReplace(getQuoteErrors['employment.occupation']) }}
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-12">
            <div class="form-group">
              <b-form-select
                plain
                autocomplete="off_employmentStatus"
                placeholder=" "
                :options="getSettingAll.employmentStatus"
                value-field="name"
                text-field="name"
                v-model="employment.employmentStatus"
              ></b-form-select>
              <label class="floatingLabel" for="employmentStatus"
                >Employment Status</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['employment.employmentStatus']"
              >
                {{ fnReplace(getQuoteErrors['employment.employmentStatus']) }}
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12">
            <div class="form-group">
              <input
                type="number"
                class="form-control"
                autocomplete="off_employerAddressTimeAtYears"
                placeholder=" "
                id="employerAddressTimeAtYears"
                min="0"
                v-model="employment.employerAddressTimeAtYears"
              />
              <label class="floatingLabel" for="employerAddressTimeAtYears"
                >Time at (Years)</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['employment.employerAddressTimeAtYears']"
              >
                {{
                  fnReplace(
                    getQuoteErrors['employment.employerAddressTimeAtYears']
                  )
                }}
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12">
            <div class="form-group">
              <input
                type="number"
                class="form-control"
                autocomplete="off_employerAddressTimeAtYears"
                placeholder=" "
                id="employerAddressTimeAtMonths"
                min="0"
                max="12"
                v-model="employment.employerAddressTimeAtMonths"
              />
              <label class="floatingLabel" for="employerAddressTimeAtMonths"
                >Time at (Months)</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['employment.employerAddressTimeAtMonths']"
              >
                {{
                  fnReplace(
                    getQuoteErrors['employment.employerAddressTimeAtMonths']
                  )
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <div class="mb-3">
              <h5 class="text-info mb-0">Employer Details</h5>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6 col-md-6 col-12">
            <div class="form-group">
              <input
                class="form-control"
                type="text"
                id="employerAddressBuildingName"
                autocomplete="off_employerAddressBuildingName"
                placeholder=" "
                v-model="employment.employerAddressBuildingName"
              />
              <label class="floatingLabel" for="employerAddressBuildingName"
                >Building Name</label
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-3 col-md-3 col-12">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                autocomplete="off_employerAddressUnitNumber"
                placeholder=" "
                id="employerAddressUnitNumber"
                v-model="employment.employerAddressUnitNumber"
              />
              <label class="floatingLabel" for="employerAddressUnitNumber"
                >Unit No</label
              >
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                autocomplete="off_employerAddressStreetNumber"
                placeholder=" "
                id="employerAddressStreetNumber"
                v-model="employment.employerAddressStreetNumber"
              />
              <label class="floatingLabel" for="employerAddressStreetNumber"
                >Street No</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['employment.employerAddressStreetNumber']"
              >
                {{
                  fnReplace(
                    getQuoteErrors['employment.employerAddressStreetNumber']
                  )
                }}
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-12">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                autocomplete="off_employerAddressStreetName"
                placeholder=" "
                id="employerAddressStreetName"
                v-model="employment.employerAddressStreetName"
              />
              <label class="floatingLabel" for="employerAddressStreetName"
                >Street Name</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['employment.employerAddressStreetName']"
              >
                {{
                  fnReplace(
                    getQuoteErrors['employment.employerAddressStreetName']
                  )
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6 col-md-6 col-12">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                autocomplete="off_employerAddressSuburb"
                placeholder=" "
                id="employerAddressSuburb"
                v-model="employment.employerAddressSuburb"
              />
              <label class="floatingLabel" for="employerAddressSuburb"
                >Suburb</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['employment.employerAddressSuburb']"
              >
                {{
                  fnReplace(getQuoteErrors['employment.employerAddressSuburb'])
                }}
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12">
            <div class="form-group">
              <b-form-select
                plain
                autocomplete="off_employerAddressState"
                placeholder=" "
                :options="getSettingAll.state"
                value-field="code"
                text-field="code"
                v-model="employment.employerAddressState"
              ></b-form-select>
              <label class="floatingLabel" for="employerAddressState"
                >State</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['employment.employerAddressState']"
              >
                {{
                  fnReplace(getQuoteErrors['employment.employerAddressState'])
                }}
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12">
            <div class="form-group">
              <input
                type="number"
                class="form-control"
                autocomplete="off_employerAddressPostcode"
                placeholder=" "
                id="employerAddressPostcode"
                v-model="employment.employerAddressPostcode"
              />
              <label class="floatingLabel" for="employerAddressPostcode"
                >Postcode</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['employment.employerAddressPostcode']"
              >
                {{
                  fnReplace(
                    getQuoteErrors['employment.employerAddressPostcode']
                  )
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-12">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                autocomplete="off_employerContactName"
                placeholder=" "
                id="employerContactName"
                v-model="employment.employerContactName"
              />
              <label class="floatingLabel" for="employerContactName"
                >Contact Name</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['employment.employerContactName']"
              >
                {{
                  fnReplace(getQuoteErrors['employment.employerContactName'])
                }}
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-12">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                autocomplete="off_employerContactNumber"
                placeholder=" "
                id="employerContactNumber"
                v-model="employment.employerContactNumber"
              />
              <label class="floatingLabel" for="employerContactNumber"
                >Contact Number</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['employment.employerContactNumber']"
              >
                {{
                  fnReplace(getQuoteErrors['employment.employerContactNumber'])
                }}
              </div>
            </div>
          </div>
        </div>

        <div
          class="row pr3000"
          v-if="fnChecklessThan3Years >= 0 && fnChecklessThan3Years < 36"
        >
          <div class="col-12">
            <p class="text-info">
              <span class=""><i class="fas fa-info-circle"></i></span
              ><span class="pl-1"
                >If employment is less than 3 years, please add additional
                employer details.</span
              >
            </p>
          </div>
        </div>
        <div v-if="fnChecklessThan3Years >= 0 && fnChecklessThan3Years < 36">
          <div class="row pr3000">
            <div class="col-12">
              <p class="mb-0 text-dark-light">Previous Employer</p>
              <hr class="mt100 secondaryHr" />
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-12">
                  <div class="form-group">
                    <input
                      class="form-control"
                      type="text"
                      id="pEmployerName"
                      autocomplete="off_pEmployerName"
                      placeholder=" "
                      v-model="employment.pEmployerName"
                    />
                    <label class="floatingLabel" for="pEmployerName"
                      >Employer Name</label
                    >
                    <div
                      class="invalid-feedback"
                      v-if="getQuoteErrors['employment.pEmployerName']"
                    >
                      {{
                        fnReplace(getQuoteErrors['employment.pEmployerName'])
                      }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-12">
                  <div class="form-group">
                    <input
                      class="form-control"
                      type="text"
                      id="pOccupation"
                      autocomplete="off_pOccupation"
                      placeholder=" "
                      v-model="employment.pOccupation"
                    />
                    <label class="floatingLabel" for="pOccupation"
                      >Occupation</label
                    >
                    <div
                      class="invalid-feedback"
                      v-if="getQuoteErrors['employment.pOccupation']"
                    >
                      {{ fnReplace(getQuoteErrors['employment.pOccupation']) }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-12">
                  <div class="form-group">
                    <b-form-select
                      plain
                      autocomplete="off_pEmploymentStatus"
                      placeholder=" "
                      :options="getSettingAll.employmentStatus"
                      value-field="name"
                      text-field="name"
                      v-model="employment.pEmploymentStatus"
                    ></b-form-select>
                    <label class="floatingLabel" for="pEmploymentStatus"
                      >Employment Status</label
                    >
                    <div
                      class="invalid-feedback"
                      v-if="getQuoteErrors['employment.pEmploymentStatus']"
                    >
                      {{
                        fnReplace(
                          getQuoteErrors['employment.pEmploymentStatus']
                        )
                      }}
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-3 col-6">
                  <div class="form-group">
                    <input
                      type="number"
                      class="form-control"
                      autocomplete="off_pEmployerAddressTimeAtYears"
                      placeholder=" "
                      id="pEmployerAddressTimeAtYears"
                      min="0"
                      v-model="employment.pEmployerAddressTimeAtYears"
                    />
                    <label
                      class="floatingLabel"
                      for="pEmployerAddressTimeAtYears"
                      >Time at (Years)</label
                    >
                    <div
                      class="invalid-feedback"
                      v-if="
                        getQuoteErrors['employment.pEmployerAddressTimeAtYears']
                      "
                    >
                      {{
                        fnReplace(
                          getQuoteErrors[
                            'employment.pEmployerAddressTimeAtYears'
                          ]
                        )
                      }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-6">
                  <div class="form-group">
                    <input
                      type="number"
                      class="form-control"
                      autocomplete="off_pEmployerAddressTimeAtYears"
                      placeholder=" "
                      id="pEmployerAddressTimeAtMonths"
                      min="0"
                      max="12"
                      v-model="employment.pEmployerAddressTimeAtMonths"
                    />
                    <label
                      class="floatingLabel"
                      for="pEmployerAddressTimeAtMonths"
                      >Time at (Months)</label
                    >
                    <div
                      class="invalid-feedback"
                      v-if="
                        getQuoteErrors[
                          'employment.pEmployerAddressTimeAtMonths'
                        ]
                      "
                    >
                      {{
                        fnReplace(
                          getQuoteErrors[
                            'employment.pEmployerAddressTimeAtMonths'
                          ]
                        )
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-12">
              <div class="form-group">
                <input
                  class="form-control"
                  type="text"
                  id="pEmployerAddressBuildingName"
                  autocomplete="off_pEmployerAddressBuildingName"
                  placeholder=" "
                  v-model="employment.pEmployerAddressBuildingName"
                />
                <label class="floatingLabel" for="pEmployerAddressBuildingName"
                  >Building Name</label
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-3 col-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  autocomplete="off_psEmployerAddressUnitNumber"
                  placeholder=" "
                  id="pEmployerAddressUnitNumber"
                  v-model="employment.pEmployerAddressUnitNumber"
                />
                <label class="floatingLabel" for="pEmployerAddressUnitNumber"
                  >Unit No</label
                >
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  autocomplete="off_pEmployerAddressStreetNumber"
                  placeholder=" "
                  id="pEmployerAddressStreetNumber"
                  v-model="employment.pEmployerAddressStreetNumber"
                />
                <label class="floatingLabel" for="pEmployerAddressStreetNumber"
                  >Street No</label
                >
                <div
                  class="invalid-feedback"
                  v-if="
                    getQuoteErrors['employment.pEmployerAddressStreetNumber']
                  "
                >
                  {{
                    fnReplace(
                      getQuoteErrors['employment.pEmployerAddressStreetNumber']
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  autocomplete="off_pEmployerAddressStreetName"
                  placeholder=" "
                  id="pEmployerAddressStreetName"
                  v-model="employment.pEmployerAddressStreetName"
                />
                <label class="floatingLabel" for="pEmployerAddressStreetName"
                  >Street Name</label
                >
                <div
                  class="invalid-feedback"
                  v-if="getQuoteErrors['employment.pEmployerAddressStreetName']"
                >
                  {{
                    fnReplace(
                      getQuoteErrors['employment.pEmployerAddressStreetName']
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  autocomplete="off_pEmployerAddressSuburb"
                  placeholder=" "
                  id="pEmployerAddressSuburb"
                  v-model="employment.pEmployerAddressSuburb"
                />
                <label class="floatingLabel" for="pEmployerAddressSuburb"
                  >Suburb</label
                >
                <div
                  class="invalid-feedback"
                  v-if="getQuoteErrors['employment.pEmployerAddressSuburb']"
                >
                  {{
                    fnReplace(
                      getQuoteErrors['employment.pEmployerAddressSuburb']
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-12">
              <div class="form-group">
                <b-form-select
                  plain
                  autocomplete="off_pEmployerAddressState"
                  placeholder=" "
                  :options="getSettingAll.state"
                  value-field="code"
                  text-field="code"
                  v-model="employment.pEmployerAddressState"
                ></b-form-select>
                <label class="floatingLabel" for="pEmployerAddressState"
                  >State</label
                >
                <div
                  class="invalid-feedback"
                  v-if="getQuoteErrors['employment.pEmployerAddressState']"
                >
                  {{
                    fnReplace(
                      getQuoteErrors['employment.pEmployerAddressState']
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-12">
              <div class="form-group">
                <input
                  type="number"
                  class="form-control"
                  autocomplete="off_pEmployerAddressPostcode"
                  placeholder=" "
                  id="pEmployerAddressPostcode"
                  v-model="employment.pEmployerAddressPostcode"
                />
                <label class="floatingLabel" for="pEmployerAddressPostcode"
                  >Postcode</label
                >
                <div
                  class="invalid-feedback"
                  v-if="getQuoteErrors['employment.pEmployerAddressPostcode']"
                >
                  {{
                    fnReplace(
                      getQuoteErrors['employment.pEmployerAddressPostcode']
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  autocomplete="off_pEmployerContactName"
                  placeholder=" "
                  id="pEmployerContactName"
                  v-model="employment.pEmployerContactName"
                />
                <label class="floatingLabel" for="pEmployerContactName"
                  >Contact Name</label
                >
                <div
                  class="invalid-feedback"
                  v-if="getQuoteErrors['employment.pEmployerContactName']"
                >
                  {{
                    fnReplace(getQuoteErrors['employment.pEmployerContactName'])
                  }}
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  autocomplete="off_pEmployerContactNumber"
                  placeholder=" "
                  id="pEmployerContactNumber"
                  v-model="employment.pEmployerContactNumber"
                />
                <label class="floatingLabel" for="pEmployerContactNumber"
                  >Contact Number</label
                >
                <div
                  class="invalid-feedback"
                  v-if="getQuoteErrors['employment.pEmployerContactNumber']"
                >
                  {{
                    fnReplace(
                      getQuoteErrors['employment.pEmployerContactNumber']
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- --------------------------Other income ------------------------------->
      <div class="col-12 col-md-12 col-lg-12 col-xl-6">
        <div class="row mt-3">
          <div class="col-12">
            <div class="mb-3">
              <h5 class="text-info mb-0">Other Income</h5>
            </div>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-12">
                <div class="form-group">
                  <input
                    type="number"
                    class="form-control"
                    autocomplete="off_investmentIncome"
                    placeholder=" "
                    id="investmentIncome"
                    v-model="employment.investmentIncome"
                  />
                  <label class="floatingLabel" for="investmentIncome"
                    >Investment Income ($)</label
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-12">
                <div class="form-group">
                  <input
                    type="number"
                    class="form-control"
                    autocomplete="off_govConvertibleIncome"
                    placeholder=" "
                    id="govConvertibleIncome"
                    v-model="employment.govConvertibleIncome"
                  />
                  <label class="floatingLabel" for="govConvertibleIncome"
                    >Centrelink Benefit Income ($)</label
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-12">
                <div class="form-group">
                  <input
                    type="number"
                    class="form-control"
                    autocomplete="off_otherIncome"
                    placeholder=" "
                    id="otherIncome"
                    v-model="employment.otherIncome"
                  />
                  <label class="floatingLabel" for="otherIncome"
                    >Other Income ($)</label
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <textarea
                type="text"
                class="form-control"
                autocomplete="off_noteOnOtherIncome"
                placeholder=" "
                rows="6"
                id="noteOnOtherIncome"
                v-model="employment.noteOnOtherIncome"
              >
              </textarea>
              <label class="floatingLabel" for="noteOnOtherIncome"
                >Note on Other Income</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <ModalQuoteSubmitConfirm
      ref="modalQuoteSubmitConfirm"
      :propsData="propsData"
      :quoteType="quoteType"
    ></ModalQuoteSubmitConfirm>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import appModalUnlockMessage from '../../components/quote/ModalUnlockMessage.vue'
import WDStepTitle from '../../components/wd/WDStepTitle.vue'
import ModalQuoteSubmitConfirm from '../../components/quote/ModalQuoteSubmitConfirm.vue'

export default {
  name: 'quoteStep3',
  props: ['propsMode', 'propsData', 'quoteType'],
  components: {
    appModalUnlockMessage,
    WDStepTitle,
    ModalQuoteSubmitConfirm
  },
  data() {
    return {
      errors: {},
      step: 3,
      isSave: false,
      quoteId: this.$route.params.quoteId,
      // client_vehicle_details
      vehicle: {
        clientId: '',
        dealerId: '',
        referralPartnerId: '',
        referDealerId: '',
        leadSource: '',
        salaryPackagingProviderId: '',
        salaryPackagingProviderFee: '',
        vehicleCondition: '',
        odometerReading: '',
        year: '',
        make: '',
        model: '',
        variant: '',
        bodyType: '',
        vehicleCategoryId: '',
        fuelFlatRate: '',
        fuelCostPerKM: '',
        tyresCostPerKM: '',
        serviceCostPerKM: '',
        transmissionId: '',
        fuelTypeId: '',
        colour: '',
        accessories: '',
        term: '',
        rvRate: '',
        annualKms: '',
        noFinanceInsurance: '',
        comprehensiveInsurer: '',
        comprehensiveInsurancePremium: '',
        businessUsePercentage: '',
        stampDuty: 0,
        registration: '',
        gstOnAsset: '',
        gstOnAssetActual: '',
        totalDriveAwayCost: '',
        chanageBudgetsYesNo: '',
        fuelBudget: '',
        serviceBudget: '',
        tyreBudget: '',
        needToCompeteYesNo: '',
        dealerBrokerage: '',
        status: '',
        sortOrder: '',
        has_messages: '',
        messages_for_vsa: '',
        messages_for_other: '',
        privacyConsent: '',
        settlementDate: '',
        fa_no: '',
        edd: ''
      },
      // Client information
      client: {
        title: '',
        gender: '',
        firstName: '',
        middleName: '',
        lastName: '',
        mobileNumber: '',
        email: '',
        grossAnnualSalary: 0,
        payPeriod: '',
        dateOfBirth: '',
        anotherNameYesNo: '',
        otherFirstName: '',
        otherMiddleName: '',
        otherLastName: '',
        driversLicenceNumber: '',
        driversLicenceCardNumber: '',
        driversLicenceExpiryDate: '',
        driversLicenceState: '',
        driversLicenceType: '',
        maritalStatus: '',
        numberOfDependents: '',
        partnerAnnualGrossSalary: '',
        australianResidencyStatusId: '',
        visaTypeId: '',
        citizenOfAnotherCountryYesNo: '',
        citizenOfAnotherCountry: '',
        hAddressUnitNumber: '',
        hAddressStreetNumber: '',
        hAddressStreetName: '',
        hAddressSuburb: '',
        hAddressState: '',
        hAddressPostcode: '',
        hAddressCountry: '',
        hAddressTimeAtYears: '',
        hAddressTimeAtMonths: '',
        hAddressResidenceStatus: '',
        hAddressMonthlyRentalAmount: '',
        pHAddressUnitNumber: '',
        pHAddressStreetNumber: '',
        pHAddressStreetName: '',
        pHAddressSuburb: '',
        pHAddressState: '',
        pHAddressPostcode: '',
        pHAddressCountry: '',
        pHAddressTimeAtYears: '',
        pHAddressTimeAtMonths: '',
        postalAddressAndHomeAddressAreSameYesNo: '',
        postalAddressPOBoxNumber: '',
        postalAddressSuburb: '',
        postalAddressState: '',
        postalAddressPostcode: '',
        status: 1
      },
      //client_employment_details
      employment: {
        quoteId: '',
        employerName: '',
        tradingName: '',
        ABNOfEmployerOnPayslip: '',
        websiteAddress: '',
        employmentStatus: '',
        occupation: '',
        employerAddressBuildingName: '',
        employerAddressUnitNumber: '',
        employerAddressStreetNumber: '',
        employerAddressStreetName: '',
        employerAddressSuburb: '',
        employerAddressState: '',
        employerAddressPostcode: '',
        employerAddressTimeAtYears: 0,
        employerAddressTimeAtMonths: 0,
        employerContactName: '',
        employerContactNumber: '',
        pEmployerName: '',
        pABNOfEmployerOnPayslip: '',
        pEmploymentStatus: '',
        pOccupation: '',
        pEmployerAddressBuildingName: '',
        pEmployerAddressUnitNumber: '',
        pEmployerAddressStreetNumber: '',
        pEmployerAddressStreetName: '',
        pEmployerAddressSuburb: '',
        pEmployerAddressState: '',
        pEmployerAddressPostcode: '',
        pEmployerAddressTimeAtYears: 0,
        pEmployerAddressTimeAtMonths: 0,
        pEmployerContactName: '',
        pEmployerContactNumber: '',
        investmentIncome: '',
        govConvertibleIncome: '',
        otherIncome: '',
        noteOnOtherIncome: ''
      },
      //client_finance_details
      finance: {
        quoteId: '',
        homePropertyValve: '',
        investmentProperty: [
          {
            value: '',
            limit: '',
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        vehicleProperty: [
          {
            value: '',
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        otherMajorVehicles: '',
        superannuationBalance: '',
        toolsAndEquipment: '',
        sharesTrustsSMSF: '',
        cashInTheBank: '',
        homeContents: '',
        otherMajorAsset: '',
        listOtherMajorAsset: '',
        homeLoanLimit: '',
        homeLoanBalance: '',
        homeLoanLenderName: '',
        homeLoanMonthlyPayment: '',
        personalLoan: [
          {
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        creditCard: [
          {
            limit: '',
            lenderName: ''
          }
        ],
        privateSchoolFees: '',
        vehicleRunningCosts: '',
        livingExpenses: '',
        insurances: '',
        ratesPowerWater: '',
        entertainment: '',
        otherMajorMonthlyExpenses: '',
        totalMonthlyExpenses: ''
      },
      //client_application_notes
      notes: {
        applicationNotes: ''
      },
      //lookup value
      lookupValues: {
        FBTRate: '0',
        GAPInsurance: '0',
        GAPInsuranceVSA: '0',
        GST: '0',
        GSTLimit: '0',
        GSTMaxOnAssets: '0',
        PPSRFee: '0',
        brokerage: '0',
        brokerageVSADefault: '0',
        brokerageVSA: '0',
        id: -1,
        financierId: -1,
        interest: '0',
        leaseAdminFee: '0',
        leaseAdminFeeVSA: '0',
        mcLeaseFee: '0',
        medicare: '0',
        quoteId: -1,
        registration: '0',
        tyreReplaceFreq: '0',
        tyreWheelInsurance: '0'
      }
    }
  },
  computed: {
    ...mapGetters([
      'getSettingAll',
      'getStepNumber',
      'getSaveApplication',
      'getQuoteSingle',
      'getIsLock',
      'getQuoteErrors'
    ]),
    fnChecklessThan3Years: function () {
      let numYears = 0
      let numMonths = 0

      if (this.employment.employerAddressTimeAtYears) {
        numYears = this.employment.employerAddressTimeAtYears
      }
      if (this.employment.employerAddressTimeAtMonths) {
        numMonths = this.employment.employerAddressTimeAtMonths
      }

      let totalMonths = Number(numYears) * 12 + Number(numMonths)

      return totalMonths
    }
  },
  methods: {
    ...mapActions([
      'fetchQuoteSingle',
      'fetchStepNumber',
      'fetchSaveApplication',
      'fetchQuoteErrors',
      'fetchIsLock'
    ]),
    fnSaveApplication: async function () {
      const allData = {
        quoteType: this.quoteType,
        propsMode: this.propsMode,
        submit_mode: 'save',
        quoteId: this.quoteId,
        vehicle: this.vehicle,
        client: this.client,
        employment: this.employment,
        finance: this.finance,
        lookupValues: this.lookupValues,
        notes: this.notes
      }

      await this.fetchSaveApplication(allData)
      await this.fetchQuoteSingle({
        id: this.quoteId,
        quoteType: this.quoteType
      })
      this.fnCallModalQuoteSubmitConfirm()
    },
    //Check whether unlock status ture
    fnCheckUnlocked(obj) {
      if (obj.quoteId == this.quoteId && obj.status == true) {
        return true
      } else {
        return false
      }
    },
    fnReplace(str) {
      const newString = str.toString().replace('[', '').replace(']', '')

      return newString
    },
    /**
     * To Show Unlock button
     */
    fnIsShowUnlockButton() {
      let status = false

      if (this.propsMode == 'edit') {
        if (
          this.propsData.status != 1 &&
          this.propsData.status != 7 &&
          this.propsData.status != 8 &&
          this.quoteType == 'quote'
        ) {
          status = true
        }

        if (
          this.propsData.status != 21 &&
          this.propsData.status != 22 &&
          this.propsData.status != 24 &&
          this.propsData.status != 25 &&
          this.propsData.status != 26 &&
          this.quoteType == 'leads'
        ) {
          status = true
        }
      }

      return status
    },
    fnCheckIsLocked(status) {
      if (
        status == 2 ||
        status == 3 ||
        status == 4 ||
        status == 5 ||
        status == 6 ||
        status == 9 ||
        status == 10 ||
        status == 11 ||
        status == 12 ||
        status == 13 ||
        status == 14 ||
        status == 23
      ) {
        this.fetchIsLock(true)
      } else {
        this.fetchIsLock(false)
      }
    },
    /**
     * Call Modal which is used to update quote status
     * if quote status in 13 or 14 into 3
     */
    fnCallModalQuoteSubmitConfirm() {
      if (this.vehicle.status == 13 || this.vehicle.status == 14) {
        const childComponent = this.$refs.modalQuoteSubmitConfirm
        if (childComponent) {
          childComponent.fnModalShow()
        }
      }
    }
  },
  watch: {
    propsData(newValue) {
      this.vehicle.clientId = newValue.clientId
      this.vehicle.dealerId = newValue.dealerId
      this.vehicle.referralPartnerId = newValue.referralPartnerId
      this.vehicle.referDealerId = newValue.referDealerId
      this.vehicle.leadSource = newValue.leadSource
      this.vehicle.salaryPackagingProviderId =
        newValue.salaryPackagingProviderId
      this.vehicle.salaryPackagingProviderFee =
        newValue.salaryPackagingProviderFee
      this.vehicle.vehicleCondition = newValue.vehicleCondition
      this.vehicle.odometerReading = newValue.odometerReading
      this.vehicle.year = newValue.year
      this.vehicle.make = newValue.make
      this.vehicle.model = newValue.model
      this.vehicle.variant = newValue.variant
      this.vehicle.bodyType = newValue.bodyType
      this.vehicle.vehicleCategoryId = newValue.vehicleCategoryId
      this.vehicle.fuelFlatRate = newValue.fuelFlatRate
      this.vehicle.fuelCostPerKM = newValue.fuelCostPerKM
      this.vehicle.tyresCostPerKM = newValue.tyresCostPerKM
      this.vehicle.serviceCostPerKM = newValue.serviceCostPerKM
      this.vehicle.transmissionId = newValue.transmissionId
      this.vehicle.fuelTypeId = newValue.fuelTypeId
      this.vehicle.colour = newValue.colour
      this.vehicle.accessories = newValue.accessories
      this.vehicle.term = newValue.term
      this.vehicle.rvRate = newValue.rvRate
      this.vehicle.annualKms = newValue.annualKms
      this.vehicle.noFinanceInsurance = newValue.noFinanceInsurance
      this.vehicle.comprehensiveInsurer = newValue.comprehensiveInsurer
      this.vehicle.comprehensiveInsurancePremium =
        newValue.comprehensiveInsurancePremium
      this.vehicle.businessUsePercentage = newValue.businessUsePercentage
      this.vehicle.stampDuty = newValue.stampDuty
      this.vehicle.registration = newValue.registration
      this.vehicle.gstOnAsset = newValue.gstOnAsset
      this.vehicle.gstOnAssetActual = newValue.gstOnAssetActual
      this.vehicle.totalDriveAwayCost = newValue.totalDriveAwayCost
      this.vehicle.chanageBudgetsYesNo = newValue.chanageBudgetsYesNo
      this.vehicle.fuelBudget = newValue.fuelBudget
      this.vehicle.serviceBudget = newValue.serviceBudget
      this.vehicle.tyreBudget = newValue.tyreBudget
      this.vehicle.needToCompeteYesNo = newValue.needToCompeteYesNo
      this.vehicle.dealerBrokerage = newValue.dealerBrokerage
      this.vehicle.status = newValue.status
      this.vehicle.sortOrder = newValue.sortOrder
      this.vehicle.has_messages = newValue.has_messages
      this.vehicle.messages_for_vsa = newValue.messages_for_vsa
      this.vehicle.messages_for_other = newValue.messages_for_other
      this.vehicle.privacyConsent = newValue.privacyConsent
      this.vehicle.settlementDate = newValue.settlementDate
      this.vehicle.fa_no = newValue.fa_no
      this.vehicle.edd = newValue.edd

      Object.assign(this.client, newValue.client)
      Object.assign(this.employment, newValue.client_employment_detail)
      Object.assign(this.finance, newValue.client_finance_detail)
      Object.assign(this.notes, newValue.client_application_notes)
      Object.assign(this.lookupValues, newValue.client_lookup_values)
      this.fnCheckIsLocked(newValue.status)
    }
  }
}
</script>
